import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Alert = _resolveComponent("Alert");
    return (_ctx.descriptionToUse !== '' || _ctx.$slots.default !== undefined)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            type: "light",
            class: "lh-2",
            extraClasses: "p-0 m-0",
            style: { "padding": "0", "margin": "0", "line-height": "1.1em", "margin-top": "4px" }
        }, {
            default: _withCtx(() => [
                _createElementVNode("small", null, [
                    _renderSlot(_ctx.$slots, "default"),
                    (_ctx.$slots.default !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " "))
                        : _createCommentVNode("", true),
                    (_ctx.descriptionToUse !== '')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            innerHTML: _ctx.descriptionToUse
                        }, null, 8, _hoisted_2))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 3
        }))
        : _createCommentVNode("", true);
}
